import React, { useState, useEffect } from 'react';
import { Form, Input, Dropdown } from "semantic-ui-react";

const SemanticCountryPhoneInput = ({ disabled, placeholder, value, onChange, defaultCountry, ...otherProps }) => {
    const [phoneValue, setPhoneValue] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(defaultCountry || 'ru');

    // Определяем список стран с их кодами и масками
    const countries = [
        { value: 'ru', text: '🇷🇺', code: '+7', mask: '+7 (___) ___-__-__', maxLength: 18 },
        { value: 'kz', text: '🇰🇿', code: '+7', mask: '+7 (___) ___-__-__', maxLength: 18 },
        { value: 'by', text: '🇧🇾', code: '+375', mask: '+375 (__) ___-__-__', maxLength: 19 },
        { value: 'ua', text: '🇺🇦', code: '+380', mask: '+380 (__) ___-__-__', maxLength: 19 },
        { value: 'us', text: '🇺🇸', code: '+1', mask: '+1 (___) ___-____', maxLength: 17 },
        { value: 'ca', text: '🇨🇦', code: '+1', mask: '+1 (___) ___-____', maxLength: 17 },
        { value: 'gb', text: '🇬🇧', code: '+44', mask: '+44 ____ ______', maxLength: 17 },
        { value: 'de', text: '🇩🇪', code: '+49', mask: '+49 ___ _______', maxLength: 17 },
        { value: 'fr', text: '🇫🇷', code: '+33', mask: '+33 _ __ __ __ __', maxLength: 17 },
        { value: 'it', text: '🇮🇹', code: '+39', mask: '+39 ___ _______', maxLength: 17 },
        { value: 'es', text: '🇪🇸', code: '+34', mask: '+34 ___ ___-___', maxLength: 16 },
        { value: 'cn', text: '🇨🇳', code: '+86', mask: '+86 ___ ____-____', maxLength: 18 },
        { value: 'jp', text: '🇯🇵', code: '+81', mask: '+81 __-____-____', maxLength: 17 },
        { value: 'in', text: '🇮🇳', code: '+91', mask: '+91 _____ _____', maxLength: 16 },
        { value: 'br', text: '🇧🇷', code: '+55', mask: '+55 (__) _____-____', maxLength: 19 },
        { value: 'au', text: '🇦🇺', code: '+61', mask: '+61 ___ ___ ___', maxLength: 16 },
        { value: 'other', text: '🌍 Другая страна', code: '+', mask: '+___ ___________', maxLength: 20 }
    ];

    useEffect(() => {
        if (value) {
            setPhoneValue(value);
        }
    }, [value]);

    useEffect(() => {
        // Добавляем глобальные стили для меню dropdown, которое рендерится в body
        const styleId = 'semantic-country-phone-dropdown-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
                .country-dropdown.active .menu,
                .ui.dropdown.country-dropdown.active .menu {
                    max-width: 62px !important;
                    min-width: auto !important;
                    width: 62px !important;
                }
                .country-dropdown.active .menu .item,
                .ui.dropdown.country-dropdown.active .menu .item {
                    padding: 0.78571429em 0.4em !important;
                    white-space: nowrap !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    max-width: 62px !important;
                }
                .ui.dropdown.country-dropdown {
                    max-width: 62px !important;
                    width: 62px !important;
                }
                .ui.dropdown.country-dropdown .text {
                    max-width: 50px !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    padding-right: 0.5em !important;
                }
            `;
            document.head.appendChild(style);
        }
        return () => {
            // Не удаляем стили при размонтировании, так как они могут использоваться другими экземплярами
        };
    }, []);

    const getCurrentCountryInfo = () => {
        return countries.find(c => c.value === selectedCountry) || countries[0];
    };

    const formatPhoneNumber = (inputValue, countryInfo) => {
        if (!inputValue) return countryInfo.code;
        
        // Убираем все, кроме цифр
        let cleaned = inputValue.replace(/\D/g, '');
        
        // Удаляем код страны из начала, если он есть
        const codeDigits = countryInfo.code.replace(/\D/g, '');
        if (cleaned.startsWith(codeDigits)) {
            cleaned = cleaned.substring(codeDigits.length);
        }

        let formatted = countryInfo.code;
        
        if (countryInfo.value === 'ru' || countryInfo.value === 'kz') {
            // +7 (999) 999-99-99
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 3)}`;
                if (cleaned.length > 3) {
                    formatted += `) ${cleaned.substring(3, 6)}`;
                    if (cleaned.length > 6) {
                        formatted += `-${cleaned.substring(6, 8)}`;
                        if (cleaned.length > 8) {
                            formatted += `-${cleaned.substring(8, 10)}`;
                        }
                    }
                }
            }
        } else if (countryInfo.value === 'us' || countryInfo.value === 'ca') {
            // +1 (999) 999-9999
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 3)}`;
                if (cleaned.length > 3) {
                    formatted += `) ${cleaned.substring(3, 6)}`;
                    if (cleaned.length > 6) {
                        formatted += `-${cleaned.substring(6, 10)}`;
                    }
                }
            }
        } else if (countryInfo.value === 'by') {
            // +375 (99) 999-99-99
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 2)}`;
                if (cleaned.length > 2) {
                    formatted += `) ${cleaned.substring(2, 5)}`;
                    if (cleaned.length > 5) {
                        formatted += `-${cleaned.substring(5, 7)}`;
                        if (cleaned.length > 7) {
                            formatted += `-${cleaned.substring(7, 9)}`;
                        }
                    }
                }
            }
        } else if (countryInfo.value === 'ua') {
            // +380 (99) 999-99-99
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 2)}`;
                if (cleaned.length > 2) {
                    formatted += `) ${cleaned.substring(2, 5)}`;
                    if (cleaned.length > 5) {
                        formatted += `-${cleaned.substring(5, 7)}`;
                        if (cleaned.length > 7) {
                            formatted += `-${cleaned.substring(7, 9)}`;
                        }
                    }
                }
            }
        } else {
            // Для других стран простое форматирование
            if (cleaned.length > 0) {
                formatted += ` ${cleaned}`;
            }
        }
        
        return formatted;
    };

    const handleCountryChange = (e, { value: countryCode }) => {
        const countryInfo = countries.find(c => c.value === countryCode) || countries[0];
        
        setSelectedCountry(countryCode);
        setPhoneValue(countryInfo.code);

        // Отправляем код страны как новое значение
        if (onChange) {
            const mockEvent = { target: { value: countryInfo.code } };
            onChange(mockEvent, { value: countryInfo.code });
        }
    };

    const handleInputChange = (e, { value: inputValue }) => {
        const countryInfo = getCurrentCountryInfo();
        
        // Разрешаем только цифры, +, (, ), -, и пробелы
        let cleanedValue = inputValue.replace(/[^+\d\s\-\(\)]/g, '');
        
        // Проверяем, не является ли это вставкой номера с 8 (fallback для случаев, когда onPaste не сработал)
        if (countryInfo.value === 'ru' && cleanedValue.includes('8') && !cleanedValue.includes('+7')) {
            // Если в тексте есть 8 и нет +7, пытаемся заменить 8 на +7
            const cleaned = cleanedValue.replace(/[^\d+]/g, '');
            if (cleaned.startsWith('8')) {
                cleanedValue = '+7' + cleaned.substring(1);
            }
        }
        
        // Форматируем номер
        const formatted = formatPhoneNumber(cleanedValue, countryInfo);
        
        setPhoneValue(formatted);
        
        if (onChange) {
            const mockEvent = { target: { value: formatted } };
            onChange(mockEvent, { value: formatted });
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        
        const countryInfo = getCurrentCountryInfo();
        let pastedText = '';
        
        try {
            // Пытаемся получить данные из буфера обмена
            pastedText = e.clipboardData.getData('text');
        } catch (error) {
            console.warn('Не удалось получить данные из буфера обмена:', error);
            return;
        }
        
        if (!pastedText) {
            return;
        }
        
        // Очищаем вставленный текст от всех символов кроме цифр и +
        let cleaned = pastedText.replace(/[^\d+]/g, '');
        
        // Если выбран регион Россия и номер начинается с 8, заменяем на +7
        if (countryInfo.value === 'ru' && cleaned.startsWith('8')) {
            cleaned = '+7' + cleaned.substring(1);
        }
        
        // Если номер начинается с +7 и выбран регион Россия, оставляем как есть
        if (countryInfo.value === 'ru' && cleaned.startsWith('+7')) {
            // Оставляем как есть
        }
        // Если номер начинается с 7 и выбран регион Россия, добавляем +
        else if (countryInfo.value === 'ru' && cleaned.startsWith('7')) {
            cleaned = '+' + cleaned;
        }
        // Если номер не содержит код страны, добавляем код выбранной страны
        else if (!cleaned.startsWith('+')) {
            cleaned = countryInfo.code + cleaned;
        }
        
        // Форматируем номер
        const formatted = formatPhoneNumber(cleaned, countryInfo);
        
        setPhoneValue(formatted);
        
        if (onChange) {
            const mockEvent = { target: { value: formatted } };
            onChange(mockEvent, { value: formatted });
        }
    };

    const handleKeyDown = (e) => {
        // Разрешаем специальные клавиши
        const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
        ];
        
        if (allowedKeys.includes(e.key)) {
            return;
        }
        
        // Разрешаем Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X (работает на любой раскладке)
        if (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
            return;
        }
        
        // Универсальная проверка по коду клавиши (работает независимо от раскладки)
        if (e.ctrlKey && ['KeyA', 'KeyC', 'KeyV', 'KeyX'].includes(e.code)) {
            return;
        }
        
        // Дополнительная проверка для русской раскладки (Ctrl+М = Ctrl+V)
        if (e.ctrlKey && e.key === 'м') {
            return;
        }
        
        // Разрешаем только цифры
        if (!/\d/.test(e.key)) {
            e.preventDefault();
        }
    };

    const countryInfo = getCurrentCountryInfo();

    return (
        <div className="semantic-country-phone-input-wrapper" style={{ marginBottom: '1em', overflow: 'visible' }}>
            <style>{`
                .semantic-country-phone-input-wrapper .ui.dropdown.country-dropdown .menu {
                    max-width: 62px !important;
                    min-width: auto !important;
                    width: 62px !important;
                }
                .semantic-country-phone-input-wrapper .ui.dropdown.country-dropdown .menu .item {
                    padding: 0.78571429em 0.4em !important;
                    white-space: nowrap !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    max-width: 62px !important;
                }
                .semantic-country-phone-input-wrapper .ui.dropdown.country-dropdown {
                    max-width: 62px !important;
                    width: 62px !important;
                }
                .semantic-country-phone-input-wrapper .ui.dropdown.country-dropdown .text {
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    white-space: nowrap !important;
                    max-width: 50px !important;
                    padding-right: 0.5em !important;
                }
            `}</style>
            <Form.Group style={{ marginBottom: '0.25em' }}>
                <Form.Field width={2} style={{maxWidth: '62px', minWidth: '57px', paddingRight: '0.5em', overflow: 'visible'}}>
                    <Dropdown
                        selection
                        options={countries}
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        disabled={disabled}
                        placeholder="Выберите страну"
                        search
                        selectOnBlur={false}
                        style={{maxWidth: '62px', width: '62px', minWidth: '57px'}}
                        className="country-dropdown"
                        {...otherProps}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        value={phoneValue}
                        placeholder={placeholder || countryInfo.mask}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        onPaste={handlePaste}
                        disabled={disabled}
                        maxLength={countryInfo.maxLength}
                    />
                </Form.Field>
            </Form.Group>
            <small style={{ fontSize: '11px', color: 'rgba(0,0,0,.6)', display: 'block', marginTop: '0.25em', marginBottom: '0', lineHeight: '1.4' }}>
                Выберите страну и введите номер телефона
            </small>
        </div>
    );
};

export default SemanticCountryPhoneInput;



// WEBPACK FOOTER //
// ./App/controls/semanticCountryPhoneInput.jsx